import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../utils/api";

export default function MfcContractPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [contract, setContract] = useState(null);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ total_amount: "", installments: 1 });
  const [dueDates, setDueDates] = useState([""]);
  const [saving, setSaving] = useState(false);

  const load = () => {
    api.get(`/mfc-clients/${id}/contract`).then(r => {
      setContract(r.data.contract);
      setPayments(r.data.payments || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, [id]);

  const handleInstallmentsChange = (val) => {
    const n = Math.max(1, Math.min(12, parseInt(val) || 1));
    setForm({ ...form, installments: n });
    setDueDates(prev => {
      const arr = [...prev];
      while (arr.length < n) arr.push("");
      return arr.slice(0, n);
    });
  };

  const createContract = async () => {
    if (!form.total_amount) { alert("Укажите сумму"); return; }
    if (dueDates.some(d => !d)) { alert("Заполните все даты платежей"); return; }
    setSaving(true);
    try {
      await api.post(`/mfc-clients/${id}/contract`, {
        total_amount: parseInt(form.total_amount),
        installments: form.installments,
        due_dates: dueDates
      });
      load();
    } catch (err) {
      alert(err.response?.data?.error || "Ошибка");
    }
    setSaving(false);
  };

  const markPaid = async (paymentId) => {
    await api.put(`/mfc-clients/payments/${paymentId}/paid`);
    load();
  };

  const cancelContract = async () => {
    if (!window.confirm("Отменить договор?")) return;
    await api.put(`/mfc-clients/${id}/contract`, { status: "cancelled" });
    load();
  };

  if (loading) return <div style={{ padding: 32, color: "#8fa0b4" }}>Загрузка...</div>;

  return (
    <div style={{ padding: "24px 32px", maxWidth: 700 }}>
      <button onClick={() => navigate("/mfc-service")} style={backBtn}>&larr; К списку клиентов</button>
      <h1 style={{ fontSize: 20, fontWeight: 700, margin: "16px 0" }}>Договор — клиент #{id}</h1>

      {!contract && (
        <div style={card}>
          <h3 style={{ margin: "0 0 16px", fontSize: 16 }}>Создать договор</h3>
          <div style={{ marginBottom: 12 }}>
            <label style={labelStyle}>Сумма (руб.)</label>
            <input type="number" value={form.total_amount} onChange={e => setForm({ ...form, total_amount: e.target.value })} style={inputStyle} placeholder="30000" />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={labelStyle}>Количество платежей</label>
            <input type="number" min="1" max="12" value={form.installments} onChange={e => handleInstallmentsChange(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Даты платежей</label>
            {dueDates.map((d, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <span style={{ fontSize: 13, color: "#64748b", minWidth: 20 }}>{i + 1}.</span>
                <input type="date" value={d} onChange={e => { const arr = [...dueDates]; arr[i] = e.target.value; setDueDates(arr); }} style={inputStyle} />
              </div>
            ))}
          </div>
          <button onClick={createContract} disabled={saving} style={primaryBtn}>{saving ? "Создаю..." : "Создать договор"}</button>
        </div>
      )}

      {contract && (
        <div style={card}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div>
              <span style={{ fontSize: 14, color: "#64748b" }}>Статус: </span>
              <span style={statusBadge(contract.status)}>{statusLabel(contract.status)}</span>
            </div>
            <div style={{ fontSize: 13, color: "#64748b" }}>
              Создан: {new Date(contract.created_at).toLocaleDateString("ru-RU")}
            </div>
          </div>

          {contract.accepted_at && (
            <div style={{ fontSize: 13, color: "#166534", background: "#dcfce7", padding: "8px 12px", borderRadius: 8, marginBottom: 16 }}>
              Принят клиентом: {new Date(contract.accepted_at).toLocaleString("ru-RU")} | IP: {contract.accepted_ip}
            </div>
          )}

          <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 12 }}>
            Сумма: {contract.total_amount.toLocaleString("ru-RU")} руб. | Платежей: {contract.installments}
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: "2px solid #e2e8f0" }}>
                <th style={thS}>#</th>
                <th style={thS}>Сумма</th>
                <th style={thS}>Дата</th>
                <th style={thS}>Статус</th>
                <th style={thS}>Действие</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((p, i) => {
                const overdue = p.status === "pending" && new Date(p.due_date) < new Date();
                return (
                  <tr key={p.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <td style={tdS}>{i + 1}</td>
                    <td style={tdS}>{p.amount.toLocaleString("ru-RU")} руб.</td>
                    <td style={tdS}>{new Date(p.due_date).toLocaleDateString("ru-RU")}</td>
                    <td style={tdS}>
                      {p.status === "paid" && <span style={{ color: "#166534", fontWeight: 600 }}>Оплачен</span>}
                      {p.status === "pending" && !overdue && <span style={{ color: "#854d0e" }}>Ожидает</span>}
                      {overdue && <span style={{ color: "#dc2626", fontWeight: 600 }}>Просрочен</span>}
                    </td>
                    <td style={tdS}>
                      {p.status !== "paid" && contract.status === "active" && (
                        <button onClick={() => markPaid(p.id)} style={smallBtn}>Оплачено</button>
                      )}
                      {p.status === "paid" && <span style={{ color: "#16a34a" }}>&#10003;</span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {contract.status !== "cancelled" && contract.status !== "completed" && (
            <div style={{ marginTop: 16, display: "flex", gap: 12 }}>
              <button onClick={cancelContract} style={dangerBtn}>Отменить договор</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function statusLabel(s) {
  if (s === "pending") return "Ожидает подтверждения";
  if (s === "active") return "Активен";
  if (s === "completed") return "Завершён";
  if (s === "cancelled") return "Отменён";
  return s;
}

function statusBadge(s) {
  const colors = { pending: "#fef9c3", active: "#dcfce7", completed: "#e0e7ff", cancelled: "#fee2e2" };
  const text = { pending: "#854d0e", active: "#166534", completed: "#3730a3", cancelled: "#991b1b" };
  return { padding: "3px 10px", borderRadius: 10, fontSize: 12, fontWeight: 600, background: colors[s] || "#f1f5f9", color: text[s] || "#64748b" };
}

const card = { background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" };
const backBtn = { background: "none", border: "none", color: "#4f6ef7", fontSize: 14, cursor: "pointer", padding: 0 };
const labelStyle = { display: "block", fontSize: 13, fontWeight: 600, color: "#475569", marginBottom: 4 };
const inputStyle = { padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 14, width: "100%", maxWidth: 220 };
const primaryBtn = { padding: "10px 24px", background: "#4f6ef7", color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer" };
const dangerBtn = { padding: "8px 16px", background: "#fee2e2", color: "#dc2626", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" };
const smallBtn = { padding: "4px 12px", background: "#dcfce7", color: "#166534", border: "none", borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: "pointer" };
const thS = { padding: "8px 10px", fontSize: 12, fontWeight: 600, color: "#64748b", textAlign: "left" };
const tdS = { padding: "8px 10px" };
